import { defaultAxios, IParams } from './base';


export interface IFetchCurrentPromotionTerms extends IParams {
  mediaCd: string;
  loanType: 'CREDIT_LOAN' | 'HOUSE_LOAN';
  custSeq: number;
}

export interface IFetchCurrentPromotion extends IParams {
    mediaCd: string;
}

export const fetchCurrentPromotionTerms = async (params: IFetchCurrentPromotionTerms) => {
  return await defaultAxios().post(`/promotion/terms/current`, params);
};

export const fetchCurrentPromotion = async (params: IFetchCurrentPromotion) => {
    return await defaultAxios().post(`/promotion/current`, params);
}
